module.exports = __webpack_public_path__ + "static/media/Bodkin of Wundor-30sec.a997e021.mp3";